module.exports = __webpack_public_path__ + "19_osu.jpg?df8c42113eb9b190354d83c9c4dd488e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/19_osu.jpg
// module id = 165
// module chunks = 0